import React, { useEffect, useState } from 'react';
import Canvas from '../Canvas';
import ToolbarFree from './ToolbarFree';
import { getMetamodel } from '../../api/metamodelsApi';
import { listEntries } from '../../api/metaRegistriesApi';
import { builtinMetamodelContext, buildMetamodelContext } from '../../utils/metamodelContext';
import { setActiveMetamodelContext } from '../../utils/monacoSetup';

const BoardFree = ({ diagramId = null, projectId = null, initialMetamodelId = null }) => {
  const [ctx, setCtx] = useState(builtinMetamodelContext());
  const [metaError, setMetaError] = useState(null);
  const [metamodelId, setMetamodelId] = useState(initialMetamodelId);
  const [defaultCode, setDefaultCode] = useState(null);

  useEffect(() => {
    if (!metamodelId || !projectId) {
      const next = builtinMetamodelContext();
      setCtx(next);
      setActiveMetamodelContext(next);
      setDefaultCode(null);
      return;
    }
    getMetamodel(projectId, metamodelId)
      .then(async (mm) => {
        setDefaultCode(mm.default_code || null);

        // Collect unique registry slugs declared on keywords
        const slugs = new Set(
          (mm.shapes ?? [])
            .map(s => s.registrySlug)
            .filter(Boolean)
        );

        let registryEntries;
        if (slugs.size > 0) {
          const entries = await Promise.all(
            Array.from(slugs).map(slug =>
              listEntries(projectId, slug, { all: true })
                .then(list => [slug, new Set(list.map(e => e.code))])
                .catch(() => [slug, new Set()])
            )
          );
          registryEntries = new Map(entries);
        }

        const next = buildMetamodelContext(mm, registryEntries);
        setCtx(next);
        setActiveMetamodelContext(next);
        setMetaError(null);
      })
      .catch((err) => {
        const next = builtinMetamodelContext();
        setCtx(next);
        setActiveMetamodelContext(next);
        setDefaultCode(null);
        if (err?.status === 404) setMetaError('Метамодель удалена — работает базовый free-режим');
        else setMetaError('Не удалось загрузить метамодель');
      });
  }, [metamodelId, projectId]);

  return (
    <>
      {metaError && (
        <div style={{ background: '#fef3c7', color: '#7c2d12', padding: '6px 12px', fontSize: 13 }}>
          {metaError}
        </div>
      )}
      <Canvas
        initialDiagramId={diagramId}
        mode="free"
        diagramMode="free"
        projectId={projectId}
        ToolbarComponent={ToolbarFree}
        metamodelContext={ctx}
        metamodelId={metamodelId}
        defaultCode={defaultCode}
        onDiagramLoaded={(diagram) => {
          const mid = diagram?.meta?.metamodelId ?? null;
          if (mid !== metamodelId) setMetamodelId(mid);
        }}
      />
    </>
  );
};

export default BoardFree;
